export const profileRoles = [
  "student",
  "instructor",
  "researcher",
  "engineer",
  "industry",
  "other",
] as const;
export type OAuthProvider = "google" | "github";
export interface UserProfile {
  firstName: string;
  lastName: string;
  organization: string;
  role: string;
  areaOfInterest?: string;
  marketingConsent?: boolean;
}
export interface AuthUser {
  suggestedProfile?: {firstName:string;lastName:string};
  profileComplete?: boolean;
  termsRequired?: boolean;
  onboardingRequired?: boolean;
  status?: "pending_profile" | "active" | "suspended";
  profile?: UserProfile | null;
  id: string;
  email: string;
  displayName: string | null;
  avatarUrl: string | null;
}
export type AuthSession =
  | { authenticated: false; user: null; expiresAt: null }
  | {
      authenticated: true;
      user: AuthUser;
      expiresAt: number | null;
      mode: "session" | "development";
    };

export interface LinkedIdentity {
  provider: OAuthProvider;
  email: string;
}
